import instance from "@/services/api";

// ошибку уже показал тостом перехватчик axios — гасим отказ, вызывающий код получает undefined
const quiet = (request) => request.catch(() => undefined);

export const promoMaterialsAPI = {
  async getList() {
    return await quiet(instance().get("/material/promo/read/").then((res) => res?.data));
  },
  async getMaterials() {
    return await quiet(instance().get("/material/promo/materials/").then((res) => res?.data));
  },
  async save(body) {
    return await quiet(instance().post("/material/promo/upd/", body).then((res) => res?.data));
  },
};

const yesNo = (value) => (value ? "Да" : "Нет");

export const promoMaterialsColumns = [
  { name: "actions", field: "actions", label: "", align: "left" },
  { name: "promo_material_id", field: "promo_material_id", label: "ID", align: "right" },
  { name: "material_id", field: "material_id", label: "ID материала", align: "right" },
  { name: "material_name", field: "material_name", label: "Материал", align: "left", viewTitle: true },
  { name: "discount_percent", field: "discount_percent", label: "Скидка, %", align: "right" },
  { name: "is_sum", field: "is_sum", label: "Суммирование", align: "center", viewValue: (r) => yesNo(r.is_sum) },
  { name: "is_active", field: "is_active", label: "Активность", align: "center", viewValue: (r) => yesNo(r.is_active) },
  {
    name: "fio", field: "fio", label: "Добавил", align: "left",
    viewValue: (r) => String(r.fio || "").replace(/<br\s*\/?>/gi, " · "),
  },
];
